import { useTranslation } from 'react-i18next';
import Badge, { type BadgeVariant } from '@/components/base/Badge';
import type { DriverAvailability } from '@/types';

const AVAILABILITY: Record<DriverAvailability, { variant: BadgeVariant; icon: string }> = {
  available: { variant: 'success', icon: 'ri-checkbox-circle-line' },
  busy: { variant: 'warning', icon: 'ri-time-line' },
  unavailable: { variant: 'neutral', icon: 'ri-pause-circle-line' },
};

export function AvailabilityBadge({ value }: { value: DriverAvailability }) {
  const { t } = useTranslation();
  const styles = AVAILABILITY[value];
  return (
    <Badge variant={styles.variant} icon={styles.icon}>
      {t(`drivers.availability.${value}`)}
    </Badge>
  );
}

export function AccountDisabledBadge() {
  const { t } = useTranslation();
  return (
    <Badge variant="danger" icon="ri-lock-line">
      {t('drivers.account.disabled')}
    </Badge>
  );
}